import { useEffect, useState } from 'react';

// hook from https://stackoverflow.com/questions/45514676/react-check-if-element-is-visible-in-dom
export default function useOnScreen(ref: any) {
  const [isIntersecting, setIntersecting] = useState(false);

  const options = { root: null, rootMargin: '0px', threshold: 1 };

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), options);
    if (ref) observer.observe(ref?.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);

  return isIntersecting;
}
